import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { PythonAPIDal } from '../dal/pythonAPI.dal';
import { RoomInterventionEstimate } from '../models/intervention-estimate.model';

@Injectable({
  providedIn: 'root',
})
export class PythonAPIService {
  constructor(private pythonAPIdal: PythonAPIDal) {}

  autoFillingByInterval(
    startDate: string,
    endDate: string,
    roomsToKeep: any[],
    roomsConfiguration: any,
    autofillingType?: string,
    population?: string,
    allowInterServiceMobility?: boolean,
    hospitals?: string[],
    sourceHospitals?: string[],
    roomsToMaintain?: string[],
    formationsGroupId?: string
  ) {
    return this.pythonAPIdal.autoFillingByInterval(
      startDate,
      endDate,
      roomsToKeep,
      roomsConfiguration,
      autofillingType,
      population,
      allowInterServiceMobility,
      hospitals,
      sourceHospitals,
      roomsToMaintain,
      formationsGroupId
    );
  }

  getRanking(
    date: string,
    surgeonopenings: any,
    roles: any,
    programs: any,
    FormationsGroups: any,
    autofillingTypes: any,
    consultExtraData: any,
    blocNeeds: any
  ): Observable<any> {
    return this.pythonAPIdal.getRanking(
      date,
      surgeonopenings,
      roles,
      programs,
      FormationsGroups,
      autofillingTypes,
      consultExtraData,
      blocNeeds
    );
  }

  autoFillingByIntervalAnesth(
    startDate: string,
    endDate: string,
    seniority?: any,
    autofillingTypes?: any,
    roomsToKeep?: any[],
    isSplitTeams?: boolean,
    hospitals?: string[],
    formationsGroupId?: string
  ) {
    return this.pythonAPIdal.autoFillingByIntervalAnesth(
      startDate,
      endDate,
      seniority,
      autofillingTypes,
      roomsToKeep,
      isSplitTeams,
      hospitals,
      formationsGroupId
    );
  }

  adjustPlanning(planningConfigId: string) {
    return this.pythonAPIdal.adjustPlanning(planningConfigId);
  }

  // getAnesthRanking(date: string): Observable<anesthsRanks> {
  //   return this.pythonAPIdal.getAnesthsRanking(date);
  // }

  getRoomsOverflowData(date: string, displayReal?: boolean): Observable<any[]> {
    return this.pythonAPIdal.getRoomsOverflowData(date, displayReal);
  }

  getInterventionOverflowData(input: string): Observable<any[]> {
    return this.pythonAPIdal.getInterventionOverflowData(input);
  }

  getRoomsOverflowOfUnsavedData(date: string, roomsWithDoctorAgendas: any): Observable<any[]> {
    return this.pythonAPIdal.getRoomsOverflowOfUnsavedData(date, roomsWithDoctorAgendas);
  }

  getInterventionEstimates(date: string): Observable<RoomInterventionEstimate[]> {
    return this.pythonAPIdal.getInterventionEstimates(date);
  }

  getSurgeonOpeningsOfSurgeonByInterval(surgeonId: string, startDate: string, endDate: string): Observable<any[]> {
    return this.pythonAPIdal.getSurgeonOpeningsOfSurgeonByInterval(surgeonId, startDate, endDate);
  }
}
